import React,{useRef,useState} from 'react';
import {pendingOpenHand} from '../../../shared/rules/monkOpenHand.mjs';
import {modifierDiceGroups,readModifierDice} from '../../../shared/rules/effects/rollDiceModifiers.mjs';
import {selectSaveD20} from '../../../shared/rules/effects/saveRollEvidence.mjs';
import CombatSavePrompt from './CombatSavePrompt';
import {useCombatantName} from './CombatantNamesContext';
import apiFetch from '../../../utils/apiFetch';
import {rollDiceWithBox,DICE_BOX_ROLL_SURFACE_EVENT} from '../../../utils/diceBoxManager';
import {notify} from '../../../utils/notification';

export default function OpenHandSavePrompt({combat,campaignId,controlledIds=[],onCombatChange,onMapReconciled,beforeRoll,onRollResult}) {
  const name=useCombatantName(),lock=useRef(false),evidence=useRef(null);
  const [resolving,setResolving]=useState(false),[error,setError]=useState('');
  const pending=pendingOpenHand(combat).find(e=>controlledIds.map(String).includes(String(e.resolution.targetId)))?.resolution;
  const automaticFailure=pending?.automaticFailure||(combat?.activeEffects||[]).some(e=>String(e.targetCombatantId)===String(pending?.targetId)&&['condition:stunned','condition:paralyzed','condition:petrified','condition:unconscious'].includes(e.definitionId));
  const answer=async choice=>{
    if(!pending||lock.current)return;
    lock.current=true;setResolving(true);setError('');
    try {
      let body=evidence.current?.id===pending.id?evidence.current.body:null;
      if(!body){
        body={choice};
        if(choice==='roll'&&!automaticFailure){
          if(beforeRoll)await beforeRoll();
          else {window.dispatchEvent(new CustomEvent(DICE_BOX_ROLL_SURFACE_EVENT,{detail:{label:'Open Hand Save'}}));await new Promise(resolve=>requestAnimationFrame(resolve));}
          const roll=await rollDiceWithBox([{count:pending.rollMode==='normal'||!pending.rollMode?1:2,sides:20},...modifierDiceGroups(pending.diceModifiers)]);
          body.saveDice=roll?.rolls?.[0];body.modifierDice=readModifierDice(roll,pending.diceModifiers);
          onRollResult?.(selectSaveD20(body.saveDice,pending.rollMode));
        }
        evidence.current={id:pending.id,body};
      }
      const response=await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/monk/open-hand/${encodeURIComponent(pending.id)}/respond`,{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),
      });
      const result=await response.json();
      if(!response.ok){if(response.status>=400&&response.status<500)evidence.current=null;throw new Error(result.message||'Open Hand save could not be saved.');}
      onCombatChange?.(result.combat);if(result.mapPayload)onMapReconciled?.(result.mapPayload);
      const r=result.resolution;
      const outcome=r.save.success?'Save successful':r.conditionImmune?'Immune to Prone':r.option==='topple'?'Prone':
        r.movement?.status==='applied'?`Pushed ${r.movement.distanceFeet} ft`:r.movement?.reason||'Push blocked';
      notify(`${name(pending.targetId,'Target')}: Open Hand · ${outcome}`,r.save.success?'success':'info');
      evidence.current=null;
    }catch(e){setError(e.message);}
    finally{lock.current=false;setResolving(false);}
  };
  return <CombatSavePrompt opportunity={pending&&!resolving?{
    sourceEffect:{displayName:`${name(pending.targetId,'Target')}: Open Hand · ${pending.option==='push'?`Push ${pending.distanceFeet} ft`:'Topple'}`},
    targetSave:{ability:pending.saveAbility,dc:pending.dc,...(pending.rollMode&&pending.rollMode!=='normal'?{rollMode:pending.rollMode}:{})},
  }:null} onRoll={()=>answer('roll')} onPass={()=>answer('pass')} error={error}>
    {automaticFailure&&<p>This creature’s condition automatically fails this save.</p>}
  </CombatSavePrompt>;
}
